// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__yEhwO","supportContact":"Footer_supportContact__2JiSY","supportEmail":"Footer_supportEmail__mJIPc","emailIcon":"Footer_emailIcon__N6fiv"};